export default "__VITE_ASSET__CAJbEvuN__"